module.exports = __webpack_public_path__ + "static/media/finance_use_case_3.02a562c6.svg";